export const fontNormalizeFactor = 1.3;
